import types from '../actionTypes';

const initialState = {
	isOpen: false,
	content: '',
	closeBtn: false,
	onCloseCallback: null,
};

function modalReducer(state = initialState, action) {
	switch (action.type) {
		case types.OPEN_MODAL:
			return {
				isOpen: true,
				content: action.content,
				closeBtn: action.closeBtn,
				onCloseCallback: action.onCloseCallback,
			};
		case types.CLOSE_MODAL:
			return initialState;
		default:
			return state;
	}
}

export default modalReducer;
